import { parsePhoneNumberFromString, PhoneNumber } from 'libphonenumber-js';

export const useIsPhoneNumberValid = () => {
    const isPhoneNumberValid = (phoneNumber: string): boolean => {
        const parsedNumber: PhoneNumber | undefined = parsePhoneNumberFromString(phoneNumber);
        return parsedNumber ? parsedNumber.isValid() : false;
    };

    return { isPhoneNumberValid };
};
